import React from "react";
import PropTypes from "prop-types";
import { Content } from "./Content";
import { Wrapper } from "./Wrapper";
import { DesignChapter } from "@learningblocks/storybook-components";
import style from "./style.module.scss";

export function Empty(props) {
  const [showOptions, setShowOptions] = React.useState(false);

  const wrapperClass = `${style.box} ${props.className}`;

  const contentClass = `${style.box_text} ${props.className}_text`;

  const renderMobileLayer = () => {
    return (
      <div
        onClick={() => setShowOptions(true)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            setShowOptions(true);
          }
        }}
        role="button"
        tabIndex={0}
        className={style.mob_expTechniqueEmpty}
      ></div>
    );
  };

  const closeModal = () => {
    setShowOptions(false);
  };
  return (
    <>
      {showOptions && (
        <DesignChapter.TechniquesOptionsModal
          onAddStep={props.onAddStep}
          list={props.options}
          isOpen={true}
          close={closeModal}
        />
      )}
      <Wrapper className={wrapperClass}>
        <Content text={props.text} className={contentClass} />
      </Wrapper>
      {renderMobileLayer()}
    </>
  );
}

Empty.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * text to display on component
   */
  text: PropTypes.string,
  /**
   * function to invoke on adding new step
   */
  onAddStep: PropTypes.func,
};

Empty.defaultProps = {
  className: "",
};
